import React from 'react';
import { Icon } from '@upsales/components';
import history from 'App/pages/routes/history';

type Props = {
	query: string;
	closeSearch: () => void;
};

const SupersearchAIActions = ({ query, closeSearch }: Props) => {
	const t = Tools.$translate;
	const trimmed = query.trim();

	if (!Tools.FeatureHelper.hasSoftDeployAccess('QUICK_SEARCH_AI')) {
		return null;
	}

	if (trimmed.length === 0) {
		return null;
	}

	const handleClick = () => {
		closeSearch();
		history.push(`/ai-workspace?q=${encodeURIComponent(trimmed)}`);
	};

	return (
		<button
			type="button"
			className="supersearch-ai-actions"
			onClick={handleClick}
			data-test-id="supersearch-ai-chat"
		>
			<Icon name="magic" />
			<span className="supersearch-ai-actions__label">
				{t('navbar.quickSearch.ai.chatAbout', { query: trimmed })}
			</span>
		</button>
	);
};

export default SupersearchAIActions;
